
// export const BASE_URL = 'http://localhost:8080/';
export const BASE_URL = 'https://funky-radish-api.herokuapp.com/';

export const REALM_APP_ID = 'funky-radish-twdxv';
